module.exports = __webpack_public_path__ + "img/m_gra.8598b5b6.svg";